'use client';

import { LinearProgress } from '@mui/material';
import { Box, Skeleton, Stack } from '@/primitives';

type Variant = 'desktop' | 'mobile';

export function SocietySearchHeaderTabsLoading({
  variant,
}: {
  variant: Variant;
}) {
  const isDesktop = variant === 'desktop';

  return (
    <Stack
      aria-busy="true"
      aria-label="Loading search tabs"
      sx={{
        flex: isDesktop ? 1 : undefined,
        minWidth: 0,
        width: isDesktop ? '100%' : '100%',
        maxWidth: isDesktop ? 520 : undefined,
        mx: isDesktop ? 'auto' : undefined,
        gap: 0.75,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {isDesktop ? (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="center"
          flexWrap="wrap"
          gap={1}
          sx={{ rowGap: 0.75 }}
        >
          <Skeleton
            variant="rounded"
            width={118}
            height={30}
            animation="wave"
            sx={{ borderRadius: '4px' }}
          />
          <Skeleton
            variant="rounded"
            width={112}
            height={30}
            animation="wave"
            sx={{ borderRadius: '4px' }}
          />
          <Skeleton
            variant="rounded"
            width={128}
            height={30}
            animation="wave"
            sx={{ borderRadius: '4px' }}
          />
        </Stack>
      ) : (
        <Skeleton
          variant="rounded"
          height={36}
          animation="wave"
          sx={{ width: '100%', borderRadius: '8px' }}
        />
      )}
      <Box sx={{ width: '100%' }}>
        <LinearProgress
          sx={{
            height: 3,
            borderRadius: 1,
            '& .MuiLinearProgress-bar': {
              borderRadius: 1,
            },
          }}
        />
      </Box>
    </Stack>
  );
}
